(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newheader"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const header = document.getElementById('site-header-{{ section.id }}');
    const drawer = document.getElementById('mobile-drawer-{{ section.id }}');
    const overlay = document.getElementById('mobile-drawer-overlay-{{ section.id }}');
    const toggle = header.querySelector('.header__mobile-toggle');
    const closeBtn = drawer.querySelector('.mobile-drawer__close');

    if (!toggle || !drawer) return;

    let lastScrollY = 0;
    const stickyThreshold = 50;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // Focus trap
      setTimeout(() => closeBtn.focus(), 100);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Sticky scroll behavior
    if (header.classList.contains('header--sticky')) {
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            header.classList.toggle('scrolled', window.scrollY > stickyThreshold);
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
